import { jsx as _jsx } from "react/jsx-runtime";
export const SourgumSixYdDimensions2 = (props) => {
    const src = new URL('./dumpster-6.png', import.meta.url).toString();
    return _jsx("img", { ...props, src: src, alt: "Six Yard Dimensions" });
};
//# sourceMappingURL=six-yard-dimensions-sourgum2.js.map